import React from 'react'
import ReactDOM from 'react-dom/client'
import 'react-day-picker/style.css'
import './index.css'
import './i18n'
import App from './App'
import { queryClient } from './lib/queryClient'
import { getMainContext } from './lib/api/booking'
import { useAuth } from './store/authStore'
import { isNativePlatform } from './lib/platform'

// Validate any stored member token on startup.
void useAuth.getState().hydrate()

// Start the first data load immediately (parallel to the bundle parse) on the shared client, then
// fade out the branded preloader once it settles — or after a safety timeout — so the home reveals
// already populated (icons + dates + time). The #gsm-preloader markup lives in index.html.
const hidePreloader = () =>
  (window as unknown as { __gsmHidePreloader?: () => void }).__gsmHidePreloader?.()
void Promise.race([
  queryClient.prefetchQuery({ queryKey: ['mainContext'], queryFn: getMainContext }),
  new Promise((res) => setTimeout(res, 2500)),
]).finally(hidePreloader)

// Register the PWA service worker on the web build (not inside Capacitor, not in dev).
if (import.meta.env.PROD && !isNativePlatform() && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {})
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
